document.addEventListener("DOMContentLoaded", function () {
  // Función para actualizar el precio por serving
  function updatePricePerServing() {
    // Seleccionamos el precio actual en el contenedor .price-container
    const priceElement = document.querySelector(
      ".price-container #ProductPrice",
    );
    if (!priceElement) return; // Si el elemento del precio no existe, salimos de la función.

    const priceText = priceElement.textContent.trim();

    // Verificamos si el precio no está vacío
    if (priceText) {
      // Extraemos solo el número, quitando el símbolo de dólar
      const priceValue = parseFloat(priceText.replace("$", ""));

      if (!isNaN(priceValue)) {
        // Dividimos el precio entre 8
        const pricePerServing = (priceValue / 8).toFixed(2);

        // Seleccionamos el contenedor donde se mostrará el precio por serving
        const priceInfoElement = document.querySelector(".product-price-info");

        // Actualizamos el contenido del div, manteniendo el span
        priceInfoElement.innerHTML = `$${pricePerServing} <span class="unit-n">/ serving</span>`;
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const videoPlayElement = document.querySelector(".miniature__video_play");

  if (videoPlayElement) {
    const backgroundImage = videoPlayElement.style.backgroundImage;
    const updatedImage = backgroundImage.replace("_small", "");
    videoPlayElement.style.backgroundImage = updatedImage;
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const packRadios = document.querySelectorAll('input[name="option1"]');
  const subRadio = document.getElementById("purchaseTypeSubscription");
  const oneTimeRadio = document.getElementById("purchaseTypeOneTime");
  const oneTimeLabel = document.querySelector(".one-time-purchase-label");
  const subscriptionLabel = document.querySelector(".subscription-label");
  const oneTimePrice = document.querySelector("[data-rtx-onetime-price]");
  const subPrice = document.querySelector("[data-rtx-subscription-price]");

  const onePackPrice = 65;

  const packQtyMap = {
    "1-Pack": 1,
    "2-Pack": 2,
    "3-Pack": 3,
  };

  function parsePrice(el) {
    if (!el) return 0;
    let text = "";
    el.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return parseFloat(text.replace(/[^0-9.]/g, "")) || 0;
  }

  function ensureSibling(anchor, selector, tagName, className) {
    if (!anchor || !anchor.parentElement) return null;
    let el = anchor.parentElement.querySelector(selector);
    if (!el) {
      el = document.createElement(tagName);
      el.className = className;
      anchor.insertAdjacentElement("afterend", el);
    }
    return el;
  }

  function ensureOneTimeBadge() {
    if (!oneTimeLabel) return null;
    return ensureSibling(
      oneTimeLabel,
      ".rosehip-one-time-savings",
      "span",
      "rosehip-one-time-savings",
    );
  }

  function ensureSubscriptionBadge() {
    if (!subscriptionLabel) return null;
    return ensureSibling(
      subscriptionLabel,
      ".rosehip-subscription-savings",
      "span",
      "rosehip-subscription-savings",
    );
  }

  function setBadge(el, savings, originalCost) {
    if (!el) return;
    if (savings > 0 && originalCost > 0) {
      const pct = Math.ceil((savings / originalCost) * 100);
      el.textContent = `Save ${pct}%`;
    } else {
      el.textContent = "";
    }
  }

  function setCompareBelow(anchor, originalCost, savings) {
    const el = ensureSibling(
      anchor,
      ".rosehip-compare-below",
      "s",
      "rosehip-compare-below",
    );
    if (!el) return;
    if (savings > 0 && originalCost > 0) {
      el.textContent = `$${Math.round(originalCost)}`;
    } else {
      el.textContent = "";
    }
  }

  function updateSavings() {
    const selectedPack = document.querySelector(
      'input[name="option1"]:checked',
    );
    const oneTimeBadge = ensureOneTimeBadge();
    const subscriptionBadge = ensureSubscriptionBadge();

    if (!selectedPack) {
      setBadge(oneTimeBadge, 0, 0);
      setBadge(subscriptionBadge, 0, 0);
      setCompareBelow(oneTimePrice, 0, 0);
      setCompareBelow(subPrice, 0, 0);
      return;
    }

    const packKey = selectedPack.getAttribute("data-option");
    const qty = packQtyMap[packKey] || 1;
    const originalCost = onePackPrice * qty;

    const oneTimeCurrent = parsePrice(oneTimePrice);
    const subCurrent = parsePrice(subPrice) || oneTimeCurrent;

    const oneTimeSavings = originalCost - oneTimeCurrent;
    const subSavings = originalCost - subCurrent;

    setBadge(oneTimeBadge, oneTimeSavings, originalCost);
    setBadge(subscriptionBadge, subSavings, originalCost);
    setCompareBelow(oneTimePrice, originalCost, oneTimeSavings);
    setCompareBelow(subPrice, originalCost, subSavings);
  }

  function scheduleUpdate() {
    setTimeout(updateSavings, 0);
  }

  packRadios.forEach((r) => r.addEventListener("change", scheduleUpdate));
  if (subRadio) subRadio.addEventListener("change", scheduleUpdate);
  if (oneTimeRadio) oneTimeRadio.addEventListener("change", scheduleUpdate);

  // rtx-pdp-nectar.js rewrites the price spans on its own events, so re-sync
  // whenever they mutate to keep our compare-at sibling in place.
  const observer = new MutationObserver(scheduleUpdate);
  [oneTimePrice, subPrice].forEach((node) => {
    if (node)
      observer.observe(node, {
        childList: true,
        characterData: true,
        subtree: true,
      });
  });

  const frequencyDropdown = document.querySelector(
    ".rtx-subscription-dropdown",
  );
  const originalSubscriptionLabelText = subscriptionLabel
    ? subscriptionLabel.textContent.trim()
    : "";

  function formatFrequencyTitle(optionText) {
    if (!optionText) return null;
    const text = optionText.trim();
    const numMatch = text.match(/(\d+)\s*(month|week|day)s?\b/i);
    if (numMatch) {
      const n = parseInt(numMatch[1], 10);
      const unit = numMatch[2].toLowerCase();
      if (n === 1) {
        return unit === "month"
          ? "Monthly Delivery"
          : unit === "week"
            ? "Weekly Delivery"
            : "Daily Delivery";
      }
      const capUnit = unit.charAt(0).toUpperCase() + unit.slice(1);
      return `${n}-${capUnit} Delivery`;
    }
    const wordMatch = text.match(/\b(monthly|weekly|daily)\b/i);
    if (wordMatch) {
      const w = wordMatch[1].toLowerCase();
      return w === "monthly"
        ? "Monthly Delivery"
        : w === "weekly"
          ? "Weekly Delivery"
          : "Daily Delivery";
    }
    return null;
  }

  function applyFrequencyTitle() {
    if (!subscriptionLabel || !frequencyDropdown) return;
    const opt =
      frequencyDropdown.selectedOptions && frequencyDropdown.selectedOptions[0];
    const text = opt ? opt.textContent : "";
    const newTitle = formatFrequencyTitle(text);
    subscriptionLabel.textContent = newTitle || originalSubscriptionLabelText;
  }

  if (frequencyDropdown) {
    frequencyDropdown.addEventListener("change", applyFrequencyTitle);
    new MutationObserver(applyFrequencyTitle).observe(frequencyDropdown, {
      childList: true,
    });
    applyFrequencyTitle();
  }

  const buyOnceTriggerLink = document.querySelector(".js-trigger-buy-once");
  const buyOnceLinkPrice = document.querySelector(".js-buy-once-link-price");
  const buyOnceLabel = document.querySelector(
    'label[for="purchaseTypeOneTime"]',
  );

  function ensureBoxShipping() {
    if (!buyOnceLabel) return null;
    const wrapper = buyOnceLabel.querySelector(".rtx-purchase-label__wrapper");
    if (!wrapper) return null;
    let el = wrapper.querySelector(".rosehip-buy-once-shipping");
    if (!el) {
      el = document.createElement("span");
      el.className = "rosehip-buy-once-shipping";
      el.style.cssText =
        "display: block; font-size: 12px; line-height: 1.3; margin-top: 3px; margin-left: 25px;";
      wrapper.appendChild(el);
    }
    return el;
  }

  const rosehipShippingBox = ensureBoxShipping();
  if (rosehipShippingBox) rosehipShippingBox.textContent = "$4.95 Shipping";

  function showBuyOnce() {
    if (buyOnceLabel) buyOnceLabel.style.display = "";
    if (buyOnceTriggerLink) buyOnceTriggerLink.style.display = "none";
  }
  function hideBuyOnce() {
    if (buyOnceLabel) buyOnceLabel.style.display = "none";
    if (buyOnceTriggerLink) buyOnceTriggerLink.style.display = "block";
  }

  function syncBuyOnceLinkPrice() {
    if (!buyOnceLinkPrice || !oneTimePrice) return;
    const txt = oneTimePrice.textContent.trim();
    if (txt) buyOnceLinkPrice.textContent = txt;
  }

  if (buyOnceTriggerLink && buyOnceLabel) {
    if (subRadio && subRadio.checked) {
      hideBuyOnce();
    } else {
      showBuyOnce();
    }

    buyOnceTriggerLink.addEventListener("click", function (e) {
      e.preventDefault();
      showBuyOnce();
      if (oneTimeRadio) oneTimeRadio.click();
    });

    if (subRadio) {
      subRadio.addEventListener("change", function () {
        if (this.checked) hideBuyOnce();
      });
    }
    if (oneTimeRadio) {
      oneTimeRadio.addEventListener("change", function () {
        if (this.checked) showBuyOnce();
      });
    }

    syncBuyOnceLinkPrice();
    if (oneTimePrice) {
      new MutationObserver(syncBuyOnceLinkPrice).observe(oneTimePrice, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  // === Split subscription card into one card per frequency ===
  const purchaseOptionsEl = document.querySelector("purchase-options");
  let productData = null;
  if (purchaseOptionsEl) {
    try {
      productData = JSON.parse(purchaseOptionsEl.getAttribute("productData"));
    } catch (e) {
      productData = null;
    }
  }

  function getCurrentVariant() {
    if (!productData) return null;
    const sel1 = document.querySelector('input[name="option1"]:checked');
    const sel2 = document.querySelector('input[name="option2"]:checked');
    const o1 = sel1 ? sel1.getAttribute("data-option") : null;
    const o2 = sel2 ? sel2.getAttribute("data-option") : null;
    return (
      productData.variants.find(
        (v) =>
          (o1 == null || v.option1 === o1) &&
          (o2 == null || v.option2 === o2),
      ) || productData.variants[0]
    );
  }

  function formatMoney(cents) {
    const { Shopify } = window;
    const currency =
      (Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    const locale = (Shopify && Shopify.locale) || "en";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function getSelectedPackCount() {
    const sel = document.querySelector('input[name="option1"]:checked');
    const key = sel ? sel.getAttribute("data-option") : null;
    return (key && packQtyMap[key]) || 1;
  }

  function bottlesLabel(count) {
    return count === 1 ? "1 bottle" : `${count} bottles`;
  }

  function describePlan(text) {
    if (!text) return "";
    const t = text.trim();
    const packCount = getSelectedPackCount();
    const bottles = bottlesLabel(packCount);
    const m = t.match(/(\d+)\s*(month|week|day)s?\b/i);
    if (m) {
      const n = parseInt(m[1], 10);
      const unit = m[2].toLowerCase();
      if (n === 1) {
        const map = { month: "monthly", week: "weekly", day: "daily" };
        return `<strong>${bottles}</strong> delivered ${map[unit]}`;
      }
      return `<strong>${bottles}</strong> delivered every ${n} ${unit}s`;
    }
    const w = t.match(/\b(monthly|weekly|daily)\b/i);
    if (w)
      return `<strong>${bottles}</strong> delivered ${w[1].toLowerCase()}`;
    return "";
  }

  function refreshCardDescriptions() {
    if (!frequencyDropdown) return;
    document.querySelectorAll(".rosehip-frequency-card").forEach((card) => {
      const planId = card.getAttribute("data-plan-id");
      const opt = Array.from(frequencyDropdown.options).find(
        (o) => o.value === planId,
      );
      if (!opt) return;
      const descTextEl = card.querySelector(".rosehip-frequency-desc__text");
      if (descTextEl) descTextEl.innerHTML = describePlan(opt.textContent.trim());
    });
  }

  function buildFrequencyCards() {
    const widget = document.querySelector(".rtx-widget");
    if (!widget || !frequencyDropdown) return;
    const planOptions = Array.from(frequencyDropdown.options).filter(
      (o) => o.value !== "",
    );
    if (planOptions.length < 2) return;

    widget.querySelectorAll(".rosehip-frequency-card").forEach((n) => n.remove());

    planOptions.forEach((opt) => {
      const planId = opt.value;
      const optText = opt.textContent.trim();
      const title = formatFrequencyTitle(optText) || optText;
      const desc = describePlan(optText);
      const isMonthly = title === "Monthly Delivery";

      const card = document.createElement("label");
      card.className = "rtx-purchase-label rosehip-frequency-card";
      card.setAttribute("data-plan-id", planId);
      card.innerHTML =
        (isMonthly
          ? '<span class="rosehip-frequency-card__banner">Most Popular</span>'
          : "") +
        '<div class="rtx-purchase-label__wrapper">' +
        '<div class="rtx-purchase-label__inner">' +
        '<input type="radio" name="rosehipFrequencyChoice" tabindex="-1" aria-hidden="true">' +
        '<span class="subscription-label rosehip-frequency-title"></span>' +
        '<span class="rosehip-savings-label"></span>' +
        '<span class="rosehip-frequency-price"></span>' +
        '<div class="rosehip-frequency-desc">' +
        '<span class="rosehip-frequency-desc__text"></span>' +
        '<s class="rosehip-frequency-desc__compare"></s>' +
        "</div>" +
        '<div class="rosehip-frequency-free-shipping"><strong>Free Shipping</strong></div>' +
        "</div>" +
        "</div>";
      card.querySelector(".rosehip-frequency-title").textContent = title;
      card.querySelector(".rosehip-frequency-desc__text").innerHTML = desc;
      widget.appendChild(card);

      card.addEventListener("click", (e) => {
        e.preventDefault();
        selectFrequencyCard(planId);
      });
    });

    refreshCardPrices();
    syncSelectedCard();
    keepBannerAtBottom();
  }

  function keepBannerAtBottom() {
    const widget = document.querySelector(".rtx-widget");
    if (!widget) return;
    const banner = widget.querySelector(".js-subscription-management-note");
    if (!banner) return;
    banner.style.order = "";
    widget.appendChild(banner);
  }

  function refreshCardPrices() {
    const variant = getCurrentVariant();
    if (!variant) return;
    const FREE_SHIPPING_THRESHOLD_CENTS = 10000;
    const MOST_POPULAR_PACK_COUNT = 3;
    const showMostPopular = getSelectedPackCount() === MOST_POPULAR_PACK_COUNT;
    document.querySelectorAll(".rosehip-frequency-card").forEach((card) => {
      const planId = card.getAttribute("data-plan-id");
      const alloc = variant.selling_plan_allocations.find(
        (a) => String(a.selling_plan_id) === String(planId),
      );
      const priceEl = card.querySelector(".rosehip-frequency-price");
      const compareEl = card.querySelector(".rosehip-frequency-desc__compare");
      const savingsEl = card.querySelector(".rosehip-savings-label");
      const freeShipEl = card.querySelector(".rosehip-frequency-free-shipping");
      const bannerEl = card.querySelector(".rosehip-frequency-card__banner");
      card.classList.toggle("is-most-popular", !!bannerEl && showMostPopular);
      if (!priceEl) return;
      if (alloc) {
        const showCompare = alloc.price < variant.price;
        priceEl.innerHTML = `<span class="rosehip-frequency-price__current">${formatMoney(alloc.price)}</span>`;
        if (compareEl) {
          compareEl.textContent = showCompare ? formatMoney(variant.price) : "";
        }
        if (savingsEl) {
          if (showCompare && variant.price > 0) {
            const pct = Math.ceil(((variant.price - alloc.price) / variant.price) * 100);
            savingsEl.textContent = pct > 0 ? `Save ${pct}%` : "";
          } else {
            savingsEl.textContent = "";
          }
        }
        if (freeShipEl) {
          freeShipEl.classList.toggle("is-visible", alloc.price > FREE_SHIPPING_THRESHOLD_CENTS);
        }
      } else {
        priceEl.textContent = "";
        if (compareEl) compareEl.textContent = "";
        if (savingsEl) savingsEl.textContent = "";
        if (freeShipEl) freeShipEl.classList.remove("is-visible");
      }
    });
  }

  function selectFrequencyCard(planId) {
    if (subRadio && !subRadio.checked) {
      subRadio.click();
    }
    if (frequencyDropdown && frequencyDropdown.value !== planId) {
      frequencyDropdown.value = planId;
      frequencyDropdown.dispatchEvent(new Event("change", { bubbles: true }));
    }
    syncSelectedCard();
  }

  function syncSelectedCard() {
    const isSubscription = subRadio && subRadio.checked;
    const currentPlan = frequencyDropdown ? frequencyDropdown.value : "";
    document.querySelectorAll(".rosehip-frequency-card").forEach((card) => {
      const planId = card.getAttribute("data-plan-id");
      const radio = card.querySelector('input[type="radio"]');
      const selected = isSubscription && planId === currentPlan;
      card.classList.toggle("is-selected", selected);
      if (radio) radio.checked = selected;
    });
  }

  function tryBuildFrequencyCards() {
    if (!frequencyDropdown) return;
    const realOptions = Array.from(frequencyDropdown.options).filter(
      (o) => o.value !== "",
    );
    if (realOptions.length >= 2) buildFrequencyCards();
  }

  if (frequencyDropdown) {
    new MutationObserver(() => {
      tryBuildFrequencyCards();
      refreshCardPrices();
      syncSelectedCard();
    }).observe(frequencyDropdown, { childList: true });
    frequencyDropdown.addEventListener("change", syncSelectedCard);
  }
  packRadios.forEach((r) =>
    r.addEventListener("change", () =>
      setTimeout(() => {
        refreshCardPrices();
        refreshCardDescriptions();
      }, 0),
    ),
  );
  if (subRadio) subRadio.addEventListener("change", syncSelectedCard);
  if (oneTimeRadio) oneTimeRadio.addEventListener("change", syncSelectedCard);

  tryBuildFrequencyCards();

  scheduleUpdate();
});
